export default [
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Trader',
    },
    cell: {
      type: 'slot',
      name: 'trader',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Direction',
    },
    cell: {
      type: 'slot',
      name: 'direction',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Trades count',
    },
    cell: {
      type: 'slot',
      name: 'tradesCount',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Completed trades count',
    },
    cell: {
      type: 'slot',
      name: 'completedTradesCount',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Completed trades amount',
    },
    cell: {
      type: 'slot',
      name: 'completedTradesAmount',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Completed trades conversion',
    },
    cell: {
      type: 'slot',
      name: 'tradesAmountConversion',
    },
  },
];
